// 订单管理-->货主和信息-->中英文
export const shipperLocale = {
    'zhCN': {
        public: {
            whetherStart: '确定启用？',
            whetherStop: '货主停用将会同步停用货主相关数据，确定停用？'
        },
        shipper: {
            shipperName: '货主名称',
            shipperCode: '货主编码',
            sAPCode: 'SAPCode',
            email: '邮箱',
            phone: '注册电话',
            fax: '传真',
            address: '注册地址',
            bank: '开户银行',
            bankNumber: '开户账号',
            mailingAddress: '邮寄地址',
            contactPerson: '签约代表',
            contactPersonPhone: '签约代表电话',
            companyCode: '公司代码',
            fTONumber: 'FTONumber',
            addShipper: '新增货主',
            updateShipper: '编辑货主',
            shipperDetail: '货主明细',
            Authentication: '实名认证',
            RealNameAuthenticationStatus: '认证状态',
            CustodianOfOfficialSeal: '系统联络人',
            confirmAuthentication: '是否重新实名认证？',
            isUploadSeal: '印章是否上传',

            // 验证相关
            shipperNameEmpty: '货主名称不能为空',
            shipperCodeEmpty: '货主编码不能为空',
            shipperCodeLength: '货主编码过长',
            fTONumberEmpty: 'FTONumber不能为空',
            fTONumberLength: 'FTONumber过长',
            companyCodeEmpty: '公司代码不能为空',
            companyCodeLength: '公司代码过长',
            sAPCodeEmpty: 'SAPCode不能为空',
            sAPCodeLength: 'SAPCode过长',
            salesOrgEmpty: 'SalesOrg不能为空',
            salesOrgLength: 'SalesOrg过长',
            phoneEmpty: '注册电话不能为空',
            phoneLength: '注册电话过长',
            shipperEMailEmpty: 'EMail不能为空',
            shipperEMailLength: 'EMail过长',
            shipperFaxEmpty: 'Fax不能为空',
            shipperFaxLength: 'Fax过长',
            validatePhone: '请填写正确的电话',
            shipperAddressEmpty: '注册地址不能为空',
            shipperAddressLength: '注册地址过长',
            shipperBankEmpty: '开户银行不能为空',
            shipperBankLength: '开户银行过长',
            shipperBankNumberEmpty: '开户账号不能为空',
            shipperBankNumberLength: '开户账号过长',
            shipperMailingAddressEmpty: '邮寄地址不能为空',
            shipperMailingAddressLength: '邮寄地址过长',
            contactPersonEmpty: '签约代表不能为空',
            shipperContactPersonLength: '签约代表过长',
            shipperContactPersonPhoneEmpty: '签约代表电话不能为空',
            shipperContactPersonPhoneLength: '签约代表电话过长',
            changeShipperDistributorMassage: '变更货主名称会影响货主库房产品关系，影响历史数据，是否确认？',
            uploadSeal: '上传印章',
            fileSizeTooLarge: '图片大小不能超过20M',
            stepUploadFormatError: '只支持png格式的印章图片',
            sealWidthHeightError: '印章尺寸高度不能超过，高度不能超过',
            mastUploadSeal: '请上传印章',
            uploadCompensationSeal: '上传补偿印章',
            compensationSeal: '补偿证明印章',
            uploadAgreementSeal: '上传协议印章',
        }
    },
    'enUS': {
        public: {
            whetherStart: 'Are you sure enable',
            whetherStop: 'Disable shipper will be synchronize the relevant data,sure？'
        },
        shipper: {
            shipperName: 'Shipper Name',
            shipperCode: 'Shipper Code',
            sAPCode: 'SAPCode',
            email: 'EMail',
            phone: 'Registe Phone',
            fax: 'Fax',
            address: 'Registe Address',
            bank: 'Bank',
            bankNumber: 'Bank Account',
            mailingAddress: 'Mailing Address',
            contactPerson: 'Signatory Representative',
            contactPersonPhone: 'Signatory Representative Phone',
            companyCode: 'Company Code',
            fTONumber: 'FTONumber.',
            addShipper: 'Add Shipper',
            updateShipper: 'Edit Shipper',
            shipperDetail: 'Shipper Detail',
            Authentication: 'Authentication',
            RealNameAuthenticationStatus: 'Authentication Status',
            CustodianOfOfficialSeal: 'Custodian Of Seal',
            confirmAuthentication: 'Do you want to re authenticate your real name? ',
            isUploadSeal: 'Is Upload Seal',

            // 验证相关
            shipperNameEmpty: 'Shipper Name can not be empty.',
            shipperCodeEmpty: 'Shipper Code can not be empty.',
            shipperCodeLength: 'Excessive length of Shipper Code.',
            fTONumberEmpty: 'FTONumber can not be empty.',
            fTONumberLength: 'Excessive length of FTONumber.',
            companyCodeEmpty: 'Company Code can not be empty.',
            companyCodeLength: 'Excessive length of Company Code.',
            validatePhone: 'Please fill in the correct Phone.',
            validateSignatoryRepresentativePhone: 'Please fill in the correct Signatory Representative Phone.',
            sAPCodeEmpty: 'SAPCode can not be empty.',
            sAPCodeLength: 'Excessive length of SAPCode.',
            salesOrgEmpty: 'SalesOrg can not be empty.',
            salesOrgLength: 'Excessive length of SalesOrg.',
            phoneEmpty: 'Registe Phone can not be empty.',
            phoneLength: 'Excessive length of Registe Phone.',
            shipperEMailEmpty: 'EMail can not be empty.',
            shipperEMailLength: 'Excessive length of EMail.',
            shipperFaxEmpty: 'Fax can not be empty.',
            shipperFaxLength: 'Excessive length of Fax.',
            shipperAddressEmpty: 'Registe Address can not be empty.',
            shipperAddressLength: 'Excessive length of Address.',
            shipperBankEmpty: 'Bank can not be empty.',
            shipperBankLength: 'Excessive length of Bank.',
            shipperBankNumberLength: 'Excessive length of Bank Card.',
            shipperBankNumberEmpty: 'Bank Card can not be empty.',
            shipperMailingAddressEmpty: 'Mailing Address can not be empty.',
            shipperMailingAddressLength: 'Excessive length of Mailing Address.',
            contactPersonEmpty: 'Signatory Representative can not be empty.',
            shipperContactPersonLength: 'Excessive length of Signatory Representative.',
            shipperContactPersonPhoneEmpty: 'Contact Person Phone can not be empty.',
            shipperContactPersonPhoneLength: 'Excessive length of Contact Person Phone.',
            changeShipperDistributorMassage: 'Change of shipperName will affect the relationship between shipper warehouse product and historical data. Are you sure?',
            uploadSeal: 'Upload Seal',
            fileSizeTooLarge: 'The maximum upload limit is exceeded. The file cannot exceed 20M.',
            stepUploadFormatError: 'Only png format files are supported.',
            sealWidthHeightError: 'The seal width can not more than，height can not more than ',
            mastUploadSeal: 'Pleas upload seal',
            uploadCompensationSeal: 'Upload Compensation Seal',
            compensationSeal: 'Compensation Seal'
        }
    }
}
export default shipperLocale



// WEBPACK FOOTER //
// ./src/locale/modules/shipperLocale.js